














import {Component, Vue} from 'vue-property-decorator';
import {traineesClient} from "@/api/clients.context";
import {TraineeProfileModel} from "@/domain/trainees/TraineeProfileModel";
import learnMathTimestables from "@/components/math/learn.math.timestables.vue";


@Component({
    components: {
        learnMathTimestables
    }
})

export default class learnMath extends Vue {
    private id: string = '';
    private profile: TraineeProfileModel | null = null;
    private topic: string | null = null;
    public selectedTables: number[] = [];
    private title: string | null = null;
    async mounted() {
        this.id = this.$route.params.id;
        this.profile = await traineesClient.getProfile(this.id);
        this.topic = this.$route.query.topic as string;


        if(this.topic=='1x1Table'){
            this.title = "Einmaleins"
        }
        else
        {
            this.title = "Mathe";
        }
    }


    private timesTableSelected(tables:number[]){
        debugger;
        this.selectedTables=tables;
    }
}
